import {getFeatureByReference} from '@apps-common/geocorn-sdk/api/features';

export const hydrateSearchGeometry = async search => {
  if (search.geometry?.type === 'ref') {
    // some older saved searches may have an array, the API does not allow this anymore.
    const featureRef = Array.isArray(search.geometry.content)
      ? search.geometry.content[0]
      : search.geometry.content;

    const hydratedGeo = await getFeatureByReference(featureRef);

    return {
      ...search,
      hydratedGeometry: hydratedGeo.geometry,
      featureReference: featureRef,
    };
  } else if (search.geometry) {
    return {
      ...search,
      hydratedGeometry: search.geometry,
    };
  } else {
    return search;
  }
};
